import { defineSlotRecipe as o } from "@pandacss/dev";
import { createAnatomy as e } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/anatomy/dist/index.mjs";
const a = e("modal", ["header", "main", "footer", "closeButton"]), m = o({
  className: "sidebar-menu",
  slots: a.keys(),
  base: {
    main: {
      flexDirection: "column",
      paddingX: "6",
      paddingTop: "2",
      paddingBottom: "6"
    },
    footer: {
      padding: "6"
    }
  }
});
export {
  m as modal
};
